import cookies from './cookies'

export default {
  namespaced: true,
  modules: {
    cookies,
  },
}
